<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('modules.edit.back') }}</router-link>
        <div class="admin-card edit-card">
            <div class="admin-section-label">
                <i class="bi bi-pencil-square"></i>
                {{ $t('modules.edit.title') }}
            </div>
            <form :action="'/api/modules/edit/' + module.id" @submit.prevent="editModule" method="post">
                <div class="form-grid">
                    <div class="form-row">
                        <label for="moduleTitle" class="form-label">{{ $t('modules.edit.form.name') }}</label>
                        <input type="text" class="form-control" name="moduleTitle" id="moduleTitle" :placeholder="$t('modules.edit.form.namePlaceholder')" v-model="module.name" required>
                    </div>
                    <div class="form-row">
                        <label for="moduleSlug" class="form-label">{{ $t('modules.edit.form.slug') }}</label>
                        <input type="text" class="form-control" id="moduleSlug" :placeholder="$t('modules.edit.form.namePlaceholder')" readonly disabled :value="module.slug">
                    </div>
                    <div class="form-row">
                        <label for="moduleDescription" class="form-label">{{ $t('modules.edit.form.description') }}</label>
                        <input type="text" class="form-control" name="moduleDescription" id="moduleDescription" :placeholder="$t('modules.edit.form.descriptionPlaceholder')" v-model="module.description" required>
                    </div>
                </div>

                <div class="functions-section">
                    <div class="admin-section-label">
                        <i class="bi bi-list-check"></i>
                        {{ $t('modules.edit.functions.title') }}
                    </div>
                    <div v-for="(f, i) in functions" :key="i" class="function-card" :id="'functionInput'+(i+1)">
                        <div class="function-card-header">
                            <span class="function-card-index">#{{ i + 1 }}</span>
                            <button v-if="functions.length > 1" type="button" class="function-card-remove" @click="removeFunction(i)" :title="$t('modules.edit.functions.remove')">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label :for="'function' + (i+1)" class="form-label">{{ $t('modules.edit.functions.name') }}</label>
                                <input type="text" class="form-control" :name="'function' + (i+1)" :id="'function' + (i+1)" v-model="functions[i].name" required>
                            </div>
                            <div class="col-md-6">
                                <label :for="'functionSelect'+(i+1)" class="form-label">{{ $t('modules.edit.functions.type') }}</label>
                                <select class="form-select" v-model="functions[i].type" :name="'functionSelect'+(i+1)" :id="'functionSelect'+(i+1)" required>
                                    <option v-for="type in types" :value="type.value" :selected="type.value === 'number'">{{ type.text }}</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label :for="'functionSlug'+(i+1)" class="form-label">{{ $t('modules.edit.functions.slug') }}</label>
                                <input type="text" class="form-control" :name="'functionSlug'+(i+1)" :id="'functionSlug'+(i+1)" readonly disabled :value="functions[i].slug">
                            </div>
                            <div class="col-12">
                                <label :for="'functionDesc'+(i+1)" class="form-label">{{ $t('modules.edit.functions.description') }}</label>
                                <input type="text" class="form-control" :name="'functionDesc'+(i+1)" :id="'functionDesc'+(i+1)" v-model="functions[i].description" required>
                            </div>
                            <input type="hidden" :name="'functionId' + (i+1)" v-model="functions[i].id">
                            <input type="hidden" :name="'functionSlug' + (i+1)" v-model="functions[i].slug">
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button type="button" class="btn-add-function" @click="addFunction">
                            <i class="bi bi-plus-lg"></i>
                            <span>{{ $t('modules.edit.functions.add') }}</span>
                        </button>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="submit" class="btn-purple">
                        <i class="bi bi-check2"></i>
                        <span>{{ $t('modules.edit.actions.save') }}</span>
                    </button>
                    <button type="button" class="btn-danger-soft" @click="showModal=true">
                        <i class="bi bi-trash"></i>
                        <span>{{ $t('modules.edit.actions.delete') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>

    <Modal
        v-model="showModal"
        :title="module.name"
        :content="$t('modules.edit.deleteModuleConfirm')"
        @confirm="confirmDelete"
    />
    <Modal
        v-model="showModal2"
        :title="$t('modules.edit.deleteFunctionTitle')"
        :index="f_index"
        :content="$t('modules.edit.deleteFunctionConfirm')"
        @confirm="confirmFunctionDelete"
    />
</template>

<script>
import Modal from '../Modal2.vue'
import Modal2 from '../Modal2.vue'

export default {
    data:() => ({
        module: {},
        functions: [],
        showModal: false,
        showModal2: false,
        f_index: false
    }),
    components: {
        Modal,
        Modal2
    },
    async mounted() {
        this.$emit('setPageTitle', this.$t('modules.edit.title'))

        this.module = await this.getModule()
        this.functions = this.module.functions
    },
    computed: {
        types() {
            return [
                { text: this.$t('modules.edit.functions.typeOptions.number'), value: 'number' },
                { text: this.$t('modules.edit.functions.typeOptions.switch'), value: 'switch' },
                { text: this.$t('modules.edit.functions.typeOptions.checkNumber'), value: 'check-number' },
                { text: this.$t('modules.edit.functions.typeOptions.checkGroup'), value: 'check-group' }
            ]
        }
    },
    methods: {
        async editModule() {
            let data = {
                title: this.module.name,
                description: this.module.description,
                functions: this.functions
            }

            let response = await this.$api.editModule(this.module.id, data)

            if(response.result === 'SUCCESS') {
                this.$router.go()
            }
        },
        async confirmDelete() {
            let response = await this.$api.deleteModule(this.module.id)
            if(response.result === 'SUCCESS') {
                this.$router.push('/modules')
            } else {
                this.$router.go()
            }
        },
        async getModule() {
            let r = await this.$api.getModule(this.$route.params.id)
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return false
            }
        },
        addFunction() {
            if(this.functions.length >= 30) return false
            this.functions.push({
                id: null,
                module_id: this.module.id,
                name: '',
                description: '',
                slug: '',
                type: 'number'
            })
        },
        removeFunction(index) {
            this.showModal2 = true
            this.f_index = index
        },
        confirmFunctionDelete(index) {
            if(this.functions.length <= 1) return false
            this.functions.splice(index, 1)
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 900px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 160px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.functions-section {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #e5e7eb;
}

.function-card {
    background: #fafbfc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 12px;
}

.function-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.function-card-index {
    font-size: 12px;
    font-weight: 600;
    color: #7c3aed;
    background: #ede9fe;
    padding: 3px 10px;
    border-radius: 999px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.function-card-remove {
    background: transparent;
    border: 1px solid #fecaca;
    color: #991b1b;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease;
}
.function-card-remove:hover {
    background: #fee2e2;
}

.btn-add-function {
    background: transparent;
    border: 1.5px dashed #cbd5e1;
    color: #64748b;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.btn-add-function:hover {
    border-color: #c4b5fd;
    background: #faf7ff;
    color: #6d28d9;
}

.btn-danger-soft {
    background: #fee2e2;
    border: 1px solid #fecaca;
    color: #991b1b;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.btn-danger-soft:hover {
    background: #fecaca;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
}
</style>
